export type ServerConfigType = {
  SCMWebSocketURL: string
}

export const ServerConfig: ServerConfigType = {
  SCMWebSocketURL: process.env.REACT_APP_SCM_WEB_SOCKET_URL ?? '',
}
